import { render, staticRenderFns } from "./OrgOwnerNotificationDropDown.vue?vue&type=template&id=3b348cea&"
import script from "./OrgOwnerNotificationDropDown.vue?vue&type=script&lang=js&"
export * from "./OrgOwnerNotificationDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports